import React from 'react';
import { Link } from 'react-router-dom';

const ways = [
  {
    title: 'Volunteer',
    description: 'Give your time and energy to help us organize events, distribute resources, and reach out to those in need in your community.',
    image: '/assets/khisa1.jpg',
    cta: 'Become a Volunteer',
    href: '/contact',
    icon: (
      <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    title: 'Donate',
    description: 'Your financial contributions go directly to supporting our programs and expanding our reach. Every cent makes a real difference.',
    image: '/assets/khisa7.jpg',
    cta: 'Donate Now',
    href: '/donate',
    icon: (
      <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    title: 'Become a Mentor',
    description: 'Share your knowledge, skills, and experience by mentoring individuals in our community — helping them grow and succeed.',
    image: '/assets/khisa6.jpg',
    cta: 'Apply to Mentor',
    href: '/contact',
    icon: (
      <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
  },
];

function GetInvolved() {
  return (
    <div>
      {/* Page header */}
      <div className="bg-gray-900 text-white py-20 px-4 text-center">
        <span className="inline-block text-red-400 text-sm font-semibold uppercase tracking-widest mb-4">Join Us</span>
        <h1 className="text-4xl md:text-6xl font-black mb-4 leading-tight">Get Involved</h1>
        <p className="text-gray-400 text-lg max-w-xl mx-auto">
          Khisa Foundation relies on the support of volunteers, donors, and mentors to empower lives and shape futures.
        </p>
      </div>

      {/* Ways to help */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {ways.map((way) => (
              <div key={way.title}
                className="group bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="relative h-48 overflow-hidden">
                  <img src={way.image} alt={way.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                </div>
                <div className="p-7">
                  <div className="w-11 h-11 bg-red-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-red-100 transition-colors">
                    {way.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{way.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-6">{way.description}</p>
                  <Link to={way.href}
                    className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm px-6 py-2.5 rounded-full transition-all duration-200 shadow-sm hover:shadow-md">
                    {way.cta}
                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-20 bg-gray-50 text-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="text-3xl font-black text-gray-900 mb-4">Have questions?</h2>
          <p className="text-gray-500 mb-8">Reach out and our team will be happy to walk you through the different ways you can make a difference.</p>
          <Link to="/contact"
            className="inline-block border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white font-semibold px-8 py-3 rounded-full transition-all duration-200">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}

export default GetInvolved;
